import styled from "styled-components";

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  overflow: hidden;
  max-height: calc(100vh - 300px);
  max-width: 800px;

  /* Hide scrollbars */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  padding: 16px 0 8px;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ErrorMessage = styled.div`
  color: ${(props) => props.theme?.colors?.red || "#f44336"};
  font-size: ${(props) => props.theme?.fontSize?.sm || "12px"};
  padding: 4px 0;
  width: 100%;
`;

